import ProductCard from './ProductCard';

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/shared/ProductCard/index.js